var initInvite = function () {
    $("#addButton").button().on("click", function () {
        $.get('/api/sitecore/Ajax/InviteUserItem', function (template) {
            $("#fieldsWrapper").append(template);
            parseDatepicker();
        });
    });
    parseDatepicker();
};

var parseDatepicker = function () {
    $("input[data-businessportal-datepicker='']").each(function() {
        var $this = $(this);
        $this.datepicker({ dateFormat: "dd/mm/yy" });
    });
};


